import React from "react";
import { useNavigate } from "react-router-dom";
import Acceptedstu from "./Acceptedstu";
import Tnpnav from "./Tnpnav";
export default function Tnphome() {

  return (
    <>
   <Tnpnav/>
  <Acceptedstu/>
    </>
  );
}
